import React from 'react';
import classnames from 'classnames';
import { TextButton } from 'scy/buttons';
import margin from 'scy/margin.mod.scss';
import { sansSerifRegular } from 'scy/text/styles.mod.scss';
import { flex, spaceBetween } from 'scy/flex.mod.scss';
import { textRight } from 'scy/utils.mod.scss';
import styles from './LineItem.mod.scss';

export default function LineItem({ format, title, display, showPromo }) {
  const isPromo = format === 'PROMO';
  const hasPromo = isPromo && display !== 'ADD';
  const modifier = (format || title || '').toLowerCase().replace(/\W+/g, '-');

  return (
    <div
      className={classnames(
        sansSerifRegular,
        margin.bottom_xxs,
        flex,
        spaceBetween,
        {
          [styles[modifier]]: !!modifier
        }
      )}
    >
      <div>{title}</div>
      <div className={textRight}>
        {isPromo ? (
          <PromoLineItem
            hasPromo={hasPromo}
            display={display}
            showPromo={showPromo}
          />
        ) : (
          display
        )}
      </div>
    </div>
  );
}

function PromoLineItem({ hasPromo, display, showPromo }) {
  return hasPromo ? (
    <div>
      <span>{display} </span>
      {showPromo && (
        <div>
          <TextButton onClick={showPromo}>Change Promo Code</TextButton>
        </div>
      )}
    </div>
  ) : (
    <TextButton onClick={showPromo}>{display}</TextButton>
  );
}
